import type { MemberStatus } from "@repo/shared";
import {
  listOrganizationMembersResponseSchema,
  ssoCancelInvitationResponseSchema,
  ssoResendInvitationResponseSchema,
  updateMemberStatusResponseSchema,
} from "@repo/shared";
import { authClient } from "../auth-client";
import { API_V1_PREFIX, apiRequestJson } from "../api-client";

export async function listMembers(organizationId: string) {
  // Org is resolved server-side from the active-org header (set by api-client).
  // The param is kept so callers/query-keys stay unchanged.
  void organizationId;
  return apiRequestJson({
    path: `${API_V1_PREFIX}/organization/members`,
    responseSchema: listOrganizationMembersResponseSchema,
    badResponseMessage: "Unexpected response from server",
  });
}

export async function removeMember(memberIdOrEmail: string, organizationId: string) {
  return authClient.organization.removeMember({ memberIdOrEmail, organizationId });
}

export async function updateMemberRole(memberId: string, role: string, organizationId: string) {
  return authClient.organization.updateMemberRole({ memberId, role, organizationId });
}

export async function updateMemberStatus(memberId: string, status: MemberStatus) {
  return apiRequestJson({
    path: `${API_V1_PREFIX}/organization/members/${memberId}/status`,
    method: "PATCH",
    body: { status },
    responseSchema: updateMemberStatusResponseSchema,
    badResponseMessage: "Unexpected response from server",
  });
}

/** Login H2J (#700): a member still waiting to activate gets the activation e-mail again. */
export async function resendMemberInvitation(memberId: string) {
  return apiRequestJson({
    path: `${API_V1_PREFIX}/organization/members/${memberId}/resend-invitation`,
    method: "POST",
    responseSchema: ssoResendInvitationResponseSchema,
    badResponseMessage: "Unexpected response from server",
  });
}

/** Login H2J (#700): takes the person out of this organization (and revokes the invite if it was their only one). */
export async function cancelMemberInvitation(memberId: string) {
  return apiRequestJson({
    path: `${API_V1_PREFIX}/organization/members/${memberId}/cancel-invitation`,
    method: "POST",
    responseSchema: ssoCancelInvitationResponseSchema,
    badResponseMessage: "Unexpected response from server",
  });
}
